import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorOptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.25 18.75H6a.75.75 0 0 1-.75-.75V6A.75.75 0 0 1 6 5.25h6.75V7.5A2.25 2.25 0 0 0 15 9.75h2.25v.75c0 .199.079.39.22.53.14.141.53.22.53.22s.39-.079.53-.22a.75.75 0 0 0 .22-.53V8.955a.982.982 0 0 0-.045-.203v-.067a.804.804 0 0 0-.142-.21l-4.5-4.5a.803.803 0 0 0-.21-.143.24.24 0 0 0-.068 0l-.24-.082H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25h5.25a.75.75 0 1 0 0-1.5Zm3-12.442 1.942 1.942H15a.75.75 0 0 1-.75-.75V6.308Z"
    />
    <path
      fill="#F7A600"
      d="M14.25 16.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Zm2.625-4.125a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25Zm0 3a.75.75 0 0 0-1.5 0v1.125a1.5 1.5 0 0 0 1.5 1.5H18a.75.75 0 0 0 0-1.5h-1.125V15.75Z"
    />
  </svg>
);
export default SvgTwoColorOptions;
